export default function parseTimezone(timezone, province = "") {
  switch (timezone) {
    case "NST":
    case "NT":
    case "NDT":
      return "Canada/Newfoundland";
    case "AST":
    case "ADT":
    case "AT":
      return "Canada/Atlantic";
    case "EST":
    case "EDT":
    case "ET":
      return "Canada/Eastern";
    case "CT":
    case "CDT":
    case "CST":
      if (province === "SK") {
        return "Canada/Saskatchewan";
      } else {
        return "Canada/Central";
      }
    case "MT":
    case "MDT":
    case "MST":
      return "Canada/Mountain";
    case "PT":
    case "PDT":
    case "PST":
      return "Canada/Pacific";
    default:
      return "Canada/Eastern";
  }
}

/**
 * Parse CSV line with proper quote handling for comma-separated values
 * @param {string} line - CSV line to parse
 * @returns {Array} - Array of parsed fields
 */
export function parseCSVLine(line) {
  const result = [];
  let current = '';
  let inQuotes = false;
  let i = 0;
  
  while (i < line.length) {
    const char = line[i];
    
    if (char === '"') {
      // Check for escaped quotes (double quotes)
      if (i + 1 < line.length && line[i + 1] === '"') {
        current += '"';
        i += 2;
      } else {
        inQuotes = !inQuotes;
        i++;
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
      i++;
    } else {
      current += char;
      i++;
    }
  }
  
  result.push(current.trim());
  return result;
}
